export default {
    setAdvancedSearchState(state,payload = {}){
        state.advancedSearchState = payload;
    },
    setAdvancedSearchDataToStore(state, payload ={}){
        for(let key of Object.keys(payload)){
            state.advancedSearchDataFromStore[key] = payload[key]
        }    
        if(payload.key != undefined){
            state.advancedSearchDataFromStore[payload.key] = payload.content
        }
    }
};